import { Box } from "@mui/material";
import { useTheme } from "@emotion/react";
import OmagunBackground from "./OmagunBackground";
import OmagunFooter from "./OmagunFooter";

// backgroundVariant: 通常はページ名がそのまま背景になるが、同じページでも状態によって
// 背景を変えたい場合(例: Hero を描かない読み込み中/エラー画面)に上書きする。
export default function OmagunLayout({ children, page = "Quests", showFooter = true, backgroundVariant = page }) {
  const theme = useTheme();
  const background = theme.backgroundStyles[page] || theme.backgroundStyles.Quests;
  const light = page === "Missions";

  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: light ? "#303030" : "#2c2c2c" }}>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          maxWidth: 414,
          minHeight: "100vh",
          mx: "auto",
          overflow: "hidden",
          ...background,
          ...(light && {
            "& footer .MuiTypography-root": { color: "#2b1b1b" },
          }),
        }}
      >
        <OmagunBackground variant={backgroundVariant} />
        <Box sx={{ position: "relative", zIndex: 1 }}>{children}</Box>
        {showFooter && (
          <Box sx={{ position: "relative", zIndex: 1 }}>
            <OmagunFooter />
          </Box>
        )}
      </Box>
    </Box>
  );
}
